import { useScrollReveal } from '@/hooks/useScrollReveal';

export default function About() {
  const [ref1, vis1] = useScrollReveal();
  const [ref2, vis2] = useScrollReveal();

  return (
    <section id="sobre" data-testid="about-section" className="py-20 sm:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          {/* Text */}
          <div
            ref={ref1}
            className={`transition-all duration-800 ${vis1 ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
          >
            <span className="inline-block px-4 py-1.5 bg-[#1A8C7A]/10 text-[#1A8C7A] text-xs font-bold tracking-wider uppercase rounded-full mb-6">
              Sobre Nós
            </span>
            <h2
              data-testid="about-title"
              className="text-2xl sm:text-3xl lg:text-4xl font-extrabold text-[#1A1A2E] leading-tight mb-6"
              style={{ letterSpacing: '-0.02em' }}
            >
              Quem Somos
            </h2>
            <p className="text-base sm:text-lg text-[#4A5568] leading-relaxed mb-8">
              Somos o Sindicato dos Pescadores e Pescadoras Artesanais do Estado do Pará e Amapá — SINDPESCA,
              uma organização interestadual sem fins lucrativos que defende os direitos e qualidade de vida
              dos pescadores e pescadoras artesanais.
            </p>
            <div className="relative pl-6 border-l-4 border-[#E8621A]">
              <p className="text-lg sm:text-xl font-bold text-[#1A8C7A] italic">
                COMPROMETIDOS COM A PESCA ARTESANAL SUSTENTÁVEL.
              </p>
            </div>
          </div>

          {/* Images Grid */}
          <div
            ref={ref2}
            className={`transition-all duration-800 delay-200 ${vis2 ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
          >
            <div className="grid grid-cols-2 gap-4">
              <div className="space-y-4">
                <div className="rounded-2xl overflow-hidden shadow-lg">
                  <img
                    src="/images/sections/05714480f5424ca96a7c0722a6baf616.jpg"
                    alt="Pescadores artesanais"
                    className="w-full h-48 object-cover hover:scale-105 transition-transform duration-500"
                  />
                </div>
                <div className="rounded-2xl overflow-hidden shadow-lg">
                  <img
                    src="/images/sections/8b99117ad57b9a9b443b94634a7a4f0c.jpg"
                    alt="Ação SINDPESCA"
                    className="w-full h-56 object-cover hover:scale-105 transition-transform duration-500"
                  />
                </div>
              </div>
              <div className="space-y-4 pt-8">
                <div className="rounded-2xl overflow-hidden shadow-lg">
                  <img
                    src="/images/sections/f383d126bdfb7d885fb54dc218535399.jpg"
                    alt="Comunidade pesqueira"
                    className="w-full h-56 object-cover hover:scale-105 transition-transform duration-500"
                  />
                </div>
                <div className="rounded-2xl overflow-hidden shadow-lg">
                  <img
                    src="/images/sections/c80f95168057afcacf59d60f76e27770.jpg"
                    alt="Pesca artesanal"
                    className="w-full h-48 object-cover hover:scale-105 transition-transform duration-500"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
